/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateInitiativeDependencyRequest
 */
export interface UpdateInitiativeDependencyRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateInitiativeDependencyRequest
     */
    dependencyType?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateInitiativeDependencyRequest
     */
    lagDays?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateInitiativeDependencyRequest
     */
    effectTenantId?: string;
}

/**
 * Check if a given object implements the UpdateInitiativeDependencyRequest interface.
 */
export function instanceOfUpdateInitiativeDependencyRequest(value: object): value is UpdateInitiativeDependencyRequest {
    return true;
}

export function UpdateInitiativeDependencyRequestFromJSON(json: any): UpdateInitiativeDependencyRequest {
    return UpdateInitiativeDependencyRequestFromJSONTyped(json, false);
}

export function UpdateInitiativeDependencyRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateInitiativeDependencyRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'dependencyType': json['dependencyType'] == null ? undefined : json['dependencyType'],
        'lagDays': json['lagDays'] == null ? undefined : json['lagDays'],
        'effectTenantId': json['effectTenantId'] == null ? undefined : json['effectTenantId'],
    };
}

export function UpdateInitiativeDependencyRequestToJSON(json: any): UpdateInitiativeDependencyRequest {
    return UpdateInitiativeDependencyRequestToJSONTyped(json, false);
}

export function UpdateInitiativeDependencyRequestToJSONTyped(value?: UpdateInitiativeDependencyRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'dependencyType': value['dependencyType'],
        'lagDays': value['lagDays'],
        'effectTenantId': value['effectTenantId'],
    };
}

